import PropTypes, { string } from 'prop-types';
import React, { useState, useEffect, useRef } from 'react';
import {DebounceInput} from 'react-debounce-input';

import Product_filters from "./Product_filters";
import { Pagination } from 'semantic-ui-react'

import delete_icon from "../../../assets/images/delete.svg";
import logo_small from "../../../assets/images/logo-small.svg";
import request_success from "../../../assets/images/request-success.svg";
import request_not_success from "../../../assets/images/request-not-success.svg";
import ua_logo from "../../../assets/images/UA.png";
import search_icon from "../../../assets/images/search.svg";
import basket_icon from "../../../assets/images/basket.svg";

const Products = (props) => {
  const [products, setProducts] = useState(props.products);
  const [products_found_count, setProductsCount] = useState(props.products_found_count);
  const [products_total_pages, setProductsTotalPages] = useState(props.products_total_pages);
  const [internationalization, setInternationalization] = useState(props.internationalization);
  const [categoryName, setCategoryName] = useState(props.currentCategoryName);
  let query_params = new URLSearchParams(window.location.search)

  const [searchVal, setSearchVal] = useState(query_params.get('search_str') || '');

  const [sortVal, setSortVal] = useState('');

  const [buyModal, setBuyModal] = useState(false);
  const [infoModal, setInfoModal] = useState(false);

  const [modalObj, setModalObj] = useState({
    productId: "",
    name: "",
    phone: ""
  })
  const [notSuccessModal, setNotSuccessModal] = useState(false);
  const [successModal, setSuccessModal] = useState(false);

  const isFirstRender = useRef(true);
  const isFirstRenderSecond = useRef(true);

  const [shouldSending, setShouldSending] = useState(false);
  const locale = props.locale.length ? `/${props.locale}` : '';
  const [mainData, setMainData] = useState({
                                              search_str: "",
                                              sorting: "",
                                              producers: [],
                                              categories: props.currentCategoryId ? [props.currentCategoryId] : [],
                                              page: 1,
                                              price: {
                                                  from: 0,
                                                  till: 0
                                              }
                                          })

  useEffect(() => {

    if (isFirstRender.current) {
      isFirstRender.current = false
      return;
    }
    setMainData({...mainData, ["page"]: 1});

  }, [searchVal, sortVal]);

  useEffect(() => {
    if (isFirstRenderSecond.current) {
      isFirstRenderSecond.current = false
      return;
    }
    sendRequest();

  }, [mainData.page, searchVal, sortVal]);

  useEffect(() => {
    if(shouldSending) {
      sendRequest();
    }
  }, [shouldSending])

  const addSortValue = (e) => {
      setMainData({...mainData, ["sorting"]: e.target.dataset.value})
      setSortVal(e.target.dataset.value);
  }

  const addSearchValue = (e) => {
    setMainData({...mainData, ["search_str"]: e.target.value});
    setSearchVal(e.target.value);
  }

  const logObj = () => {
    console.log(mainData)
  }

  const addPriceValue = (e) => {
    if (e.target.id === "from") {
      setMainData({...mainData, ["price"]: {...mainData["price"], ["from"]: e.target.value}})
    } else {
      setMainData({...mainData, ["price"]: {...mainData["price"], ["till"]: e.target.value}})
    }
  }

  const addCheckboxField = (e) => {
    let arr = mainData[e.target.dataset.category];
    let option = Number(e.target.id.match(/\d+/g)[0]);
    if(arr.includes(option)) {
      arr.splice(arr.indexOf(option), 1)
    } else {
      arr.push(option);
    }
    setMainData({...mainData, [e.target.dataset.category]: arr})
    setShouldSending(false);
  }

  const clearAllData = () => {
    setMainData({...mainData, producers: [], categories: props.currentCategoryId ? [props.currentCategoryId] : [],  price: {
      from: 0,
      till: 0
    }});
    if (mainData.page == 1){
      setShouldSending(true)
    } else {
     setMainData({...mainData, ["page"]: 1});
    }
  }

  const clearSingleOption = (optionToDelete) => {
    let arr = mainData[optionToDelete.category];

    if (optionToDelete.subcategory) {
      setMainData({...mainData, ["price"]: {...mainData["price"], [optionToDelete.subcategory]: 0}})
    } else {
      arr.splice(arr.indexOf(Number(optionToDelete.value.slice(-1))), 1);
      setMainData({...mainData, [optionToDelete.category]: arr})
    }
  }

  //request
  const sendRequest = () => {
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': props.authToken },
      body: JSON.stringify(mainData)
    };

    fetch(`${locale}/products`, requestOptions)
    .then((response) => {
      if (response.status > 204) {
        throw new Error("Not success");
      }
      return response.json();
    })
    .then((data) => {
      setProducts(data.products);
      setProductsCount(data.products_found_count);
      setProductsTotalPages(data.products_total_pages);
    })
    .catch((error) => console.log(error));
  }

  const paginate = (event, item) => {
    setMainData({...mainData, ["page"]: item.activePage});
  };

  const submitFilter = () => {
    if (mainData.page == 1){
      sendRequest();
    } else {
      setMainData({...mainData, ["page"]: 1});
    }
  };

  const openBuyingModal = (productId) => {
    setBuyModal(true);
    setModalObj({...modalObj, ["productId"]: productId})
  }

  const openInfoModal = (productId) => {
    setInfoModal(true);
    setModalObj({...modalObj, ["productId"]: productId})
  }

  const handleName = (e) => {
    setModalObj({...modalObj, ["name"]: e.target.value})
  }

  const handlePhone = (e) => {
    setModalObj({...modalObj, ["phone"]: toString(e.target.value)})
  }

  const closeModal = () => {
    setBuyModal(false)
    setInfoModal(false)
    setNotSuccessModal(false)
    setSuccessModal(false)
    setModalObj({
      productId: "",
      name: "",
      phone: ""
    })
  }

  const sendModalRequest = (endpoint) => {

    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': props.authToken },
      body: JSON.stringify(modalObj)
    };

    fetch(endpoint, requestOptions)
    .then((response) => {

      setInfoModal(false);
      setBuyModal(false)
      setModalObj({
        productId: "",
        name: "",
        phone: ""
      })

      if (response.status > 204) {
        setNotSuccessModal(true)
      } else {
        setSuccessModal(true)
      }
    })
    .catch((error) => console.log(error));
  }

  const price_with_currency = (price, currency) => {
    switch (currency) {
      case "USD":
        return `$${price}`
      case "EUR":
        return `€${price}`
      default:
        return `${price} грн`
    }
  }
  return (

  <section className="catalog" id="catalog">
  <div className="flex_container breadCrumbs_container">
    <div className="breadCrumbs">
      {props.breadcrumb.map((breadcrumb_item, index) => {
        return <a href={breadcrumb_item.path} className="breadCrumbs-link"> {breadcrumb_item.name}</a>
      })}
    </div>
  </div>
  <div className="flex_container catalog-container">
      <img src={ua_logo} alt="logo" className="top-site-bg_image"></img>
      <div className="catalog-top">
            {categoryName !== null ?
                  <div className="catalog-top-title">
                      <h1>{categoryName}</h1>
                  </div>
                :
                  <div className="catalog-top-title">
                    <h1>{internationalization.catalog_title}</h1>
                    <span>{props.productsCount} {internationalization.counter_products}</span>
                  </div>
            }
          <div className="catalog-top-tabs">
            <a href={`${locale}/products`} className="catalog-top-tabs-item catalog-top-tabs-item-active"> {internationalization.all_products}</a>
            <a href={`${locale}/goods`} className="catalog-top-tabs-item">{internationalization.catalog_subtitle}</a>
              {/* <%= link_to "Все товары", products_path, className: "catalog-top-tabs-item catalog-top-tabs-item-active" %>
              <%= link_to "Категории", goods_path, className: "catalog-top-tabs-item" %> */}
          </div>
          <button className="filter-open-mob green-link">{internationalization.catalog_filters}</button>
      </div>
    <div className="catalog-content">

        <Product_filters addPriceValue={addPriceValue}
                         addCheckboxField={addCheckboxField}
                         producers={props.producers}
                         categories={props.categories}
                         clearSingleOption={clearSingleOption}
                         clearAllData={clearAllData}
                         submitFilter={submitFilter}
                         internationalization={internationalization}
                         categories={props.categories}/>

        <div className="catalog-content-main">

            <div className="catalog-content-main-top">
                <div className="sort-wrapper">
                    <div className="sort-select">
                        <div className="sort__trigger"><span>{internationalization.sort_by}</span>
                            <div className="arrow"></div>
                        </div>
                        <div className="sort-options">
                            <span className="sort-option" data-value="price-lowest" onClick={(e) => addSortValue(e)}>{internationalization.sort_by_raice_price}</span>
                            <span className="sort-option" data-value="price-highest" onClick={(e) => addSortValue(e)}>{internationalization.sort_by_low_price}</span>
                            <span className="sort-option" data-value="new" onClick={(e) => addSortValue(e)}>{internationalization.sort_by_news}</span>
                            <span className="sort-option" data-value="hits" onClick={(e) => addSortValue(e)}>{internationalization.sort_by_hits}</span>
                        </div>
                    </div>
                </div>
                <div className="catalog-search">
                    <div className="search-block-field">
                        <DebounceInput
                            minLength={1}
                            debounceTimeout={300}
                            value={searchVal}
                            className={"search-block-field-input"}
                            onChange={event => addSearchValue(event)} />
                        <button className="search-block-field-button" type="send"> <img src={search_icon} alt="search icon"></img> </button>
                        <div className="goods-found">
                            <span onClick={() => logObj()}>{internationalization.found}: {products_found_count} {internationalization.counter_products}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="catalog-content-main-empty" style={products.length > 0 ? {display: "none"} : {display: "block"}}>
                <h5>{internationalization.not_found_title}</h5>
                <p>{internationalization.not_found_subtitle}</p>
            </div>

            <div className="catalog-content-main-cards">

              {products.map((product, index) => {
                return   <div key={index} id={product.id} className={`main-card-wrap ${product.is_hit ? "main-card-hit" : product.is_new ? "main-card-new" : product.is_sale ? "main-card-discount" : "main-card-unavalible"}`}>
                            <div className="main-card">
                                <a className="main-card-img-link" href={`${locale}/goods/${product.category.slug}/${product.slug}`}>
                                    <img src={product.preview_image_url} alt={`${product.localazed_name} фото`}></img>
                                    <h6>{product.localazed_name}</h6>
                                    {product.is_sale &&
                                      <span className="main-card-img-link-discount">-15%</span>
                                    }
                                </a>
                                <span className="main-card-country">{product.producer ? product.producer.localazed_name : "Производитель не указан"}{product.producer ? ` (${product.producer.country})` : ""}</span>
                                <span className="main-card-mark">{product.is_hit ? "Хит!" : product.is_new ? "NEW" : ""}</span>

                                  {product.is_sale &&
                                    <div className="main-card-bying-block">
                                        <div className="main-card-bying-block-prices">
                                              <span className="main-card-bying-block-price-old">{price_with_currency(product.price, product.currency)}</span>
                                              <span className="main-card-bying-block-price">{price_with_currency(product.sale_price, product.currency)}</span>
                                        </div>
                                        <button className="main-card-bying-block-basket">
                                          <img src={basket_icon} alt="basket icon"></img>
                                        </button>
                                      </div>
                                  }
                                  {(!product.is_sale && product.price > 0) &&
                                    <div className="main-card-bying-block">
                                        <span className="main-card-bying-block-price">{price_with_currency(product.price, product.currency)}</span>
                                        <button className="main-card-bying-block-basket">
                                          <img src={basket_icon} alt="basket icon"></img>
                                        </button>
                                    </div>
                                  }
                                  {product.price === 0 &&
                                    <div className="main-card-bying-block">
                                      <button className="green-bordered-link" onClick={() => openInfoModal(product.id)}>{internationalization.clarify_price}</button>
                                    </div>
                                  }
                                  {product.price > 0 &&
                                    <div className="main-card-buy_btn">
                                        <button className="main-card-buy_btn-button" onClick={() => openBuyingModal(product.id)}>{internationalization.buy_one_click}</button>
                                    </div>
                                  }
                            </div>
                        </div>
              })}
              { products_total_pages > 1 &&
                <Pagination
                    activePage={mainData.page}
                    firstItem={null}
                    lastItem={null}
                    totalPages={products_total_pages}
                    onPageChange={paginate}
                    boundaryRange={0}
                  />
              }
            </div>

        </div>
    </div>

    </div>

    <div className={`main-modal main-modal-price ${infoModal ? "main-modal-visible" : ""}`}>
      <div className="main-modal-overlay" onClick={() => closeModal()}></div>
      <div className="main-modal-content">
            <span className="main-modal-content-close" onClick={() => closeModal()}><img src={delete_icon} alt="delete icon"></img></span>
            <h5 className="main-modal-content-title">{internationalization.clarify_price}</h5>
            <p className="main-modal-content-text">{internationalization.clarify_price_modal_title}</p>
            <input className="form-field form-field-text" onChange={(e) => handleName(e)} type="text" placeholder={internationalization.clarify_price_modal_name_field}></input>
            <input className="form-field form-field-number" onChange={(e) => handlePhone(e)} type="number" placeholder={internationalization.accepting_order_modal_payer_phone}></input>
            <button className="submit-btn green-link" onClick={() => sendModalRequest("/products/clarify_price")}>{internationalization.clarify_price_modal_submit}</button>
      </div>
    </div>

    <div className={`main-modal main-modal-card ${buyModal ? "main-modal-visible" : ""}`}>
      <div className="main-modal-overlay" onClick={() => closeModal()}></div>
      <div className="main-modal-content">
      <span className="main-modal-content-close" onClick={() => closeModal()}><img src={delete_icon} alt="delete icon"></img></span>
            <h5 className="main-modal-content-title">{internationalization.buy_one_click}</h5>
            <p className="main-modal-content-text">{internationalization.one_click_modal_title}</p>
            <input className="form-field form-field-text" onChange={(e) => handleName(e)} type="text" placeholder={internationalization.clarify_price_modal_name_field}></input>
            <input className="form-field form-field-number" onChange={(e) => handlePhone(e)} type="number" placeholder={internationalization.accepting_order_modal_payer_phone}></input>
            <button className="submit-btn green-link" onClick={() => sendModalRequest("/personal/one_click_purchase")}>{internationalization.clarify_price_modal_submit}</button>
      </div>
    </div>

    <div className={`main-modal main-modal-info main-modal-info-success ${successModal ? "main-modal-visible" : ""}`}>
        <div className="main-modal-overlay" onClick={() => closeModal()}></div>
        <div className="main-modal-content">
              <span className="main-modal-content-close" onClick={() => closeModal()}><img src={delete_icon} alt="delete icon"></img></span>
              <img className="main-modal-content-bg" src={logo_small} alt="logo small"></img>
              <img className="main-modal-content-icon" src={request_success} alt="success icon"></img>
              <h5 className="main-modal-content-title">{internationalization.success_request}</h5>
        </div>
    </div>

    <div className={`main-modal main-modal-info main-modal-info-not-success ${notSuccessModal ? "main-modal-visible" : ""}`}>
          <div className="main-modal-overlay" onClick={() => closeModal()}></div>
          <div className="main-modal-content">
                <span className="main-modal-content-close" onClick={() => closeModal()}><img src={delete_icon} alt="delete icon"></img></span>
                <img className="main-modal-content-bg" src={logo_small} alt="logo small"></img>
                <img className="main-modal-content-icon" src={request_not_success} alt="not success"></img>
                <h5 className="main-modal-content-title">{internationalization.failure_request}</h5>
          </div>
    </div>

    </section>
  )

};

export default Products;
